var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "880.000000pt",
    height: "1060.000000pt",
    viewBox: "0 0 880.000000 1060.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1060.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4315 10187 c-90 -30 -10 37 -1305 -1112 -697 -619 -1037 -920 -1425 -1263 -225 -199 -426 -383 -447 -409 -103 -130 -88 -322 34 -440 66 -65 126 -88 228 -88 71 0 94 4 140 26 41 20 295 239 1000 864 1448 1284 1511 1340 1521 1343 5 2 9 -1215 9 -2982 l0 -2985 21 -58 c28 -72 94 -144 168 -180 48 -24 68 -28 141 -28 73 0 93 4 141 28 74 36 140 108 168 180 l21 58 0 2984 c0 1642 3 2985 6 2985 3 0 23 -15 43 -32 35 -30 1631 -1445 2185 -1937 283 -251 308 -266 436 -266 102 0 162 23 228 88 120 116 136 305 39 434 -18 24 -716 650 -1552 1393 -1131 1005 -1534 1357 -1573 1376 -65 31 -168 40 -227 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 4186 c-89 -29 -154 -86 -200 -176 l-28 -55 0 -1415 0 -1415 26 -55 c37 -80 81 -125 157 -162 l67 -33 3745 0 3745 0 67 33 c76 37 120 82 157 162 l26 55 0 1415 0 1415 -29 58 c-35 68 -98 130 -164 160 -37 17 -66 22 -137 22 -83 0 -95 -2 -153 -34 -74 -40 -115 -84 -151 -161 l-26 -55 -3 -1202 -2 -1203 -3330 0 -3330 0 -2 1203 -3 1202 -27 57 c-33 70 -97 136 -163 167 -61 30 -179 38 -242 17z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.b1117eac96d0a13e2b3968bb9f426cef.svg";
export { ForwardRef as ReactComponent };